import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTables } from '../../services/api';

function TableSelectionScreen() {
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTables = async () => {
      try {
        const data = await getTables();
        setTables(data);
      } catch (err) {
        console.error('Failed to fetch tables:', err);
        setError('Não foi possível carregar as mesas.');
      } finally {
        setLoading(false);
      }
    };

    fetchTables();
  }, []);

  const handleTableSelect = (tableId) => {
    navigate(`/waiter/order/${tableId}`); // Redireciona para a tela de pedido com o ID da mesa
  };

  if (loading) {
    return <div style={styles.loading}>Carregando mesas...</div>;
  }

  if (error) {
    return <div style={styles.error}>{error}</div>;
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Seleção de Mesa</h2>
      <div style={styles.tableGrid}>
        {tables.map((table) => (
          <div
            key={table.TableID}
            style={{
              ...styles.tableCard,
              backgroundColor: table.Status === 'occupied' ? '#ffcccc' : '#ccffcc',
              cursor: table.Status === 'occupied' ? 'not-allowed' : 'pointer',
            }}
            onClick={() => table.Status === 'free' && handleTableSelect(table.TableID)}
          >
            <h3>Mesa {table.TableNumber}</h3>
            <p>Status: {table.Status === 'free' ? 'Livre' : 'Ocupada'}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    backgroundColor: '#f0f2f5',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
  },
  title: {
    color: '#333',
    marginBottom: '30px',
  },
  tableGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
    gap: '20px',
    width: '100%',
    maxWidth: '900px',
  },
  tableCard: {
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    transition: 'transform 0.2s',
  },
  tableCardHover: {
    transform: 'scale(1.03)',
  },
  loading: {
    fontSize: '18px',
    color: '#555',
    marginTop: '50px',
  },
  error: {
    fontSize: '18px',
    color: 'red',
    marginTop: '50px',
  },
};

export default TableSelectionScreen;
